import { IIdentityVerificationTokenResponse } from "@wingspanhq/users";
import { serviceUser } from "../user";

export const startIdentityVerification = async (
  identityVerificationId: string
) => {
  const response = await serviceUser.post<IIdentityVerificationTokenResponse>(
    `/identity-verification/${identityVerificationId}/start`
  );
  return response.data;
};
